{
  "tabs": {
    "chat": "Чат",
    "reminders": "Напомняния",
    "calendar": "Календар",
    "settings": "Настройки"
  },
  "common": {
    "cancel": "Отказ",
    "save": "Запази",
    "confirm": "Потвърди",
    "delete": "Изтрий",
    "back": "Назад",
    "close": "Затвори",
    "edit": "Редактирай",
    "search": "Търсене",
    "all": "Всички",
    "loading": "Зареждане...",
    "error": "Нещо се обърка",
    "notFound": "Не е намерено",
    "tryAgain": "Моля, опитайте отново",
    "retry": "Опитай пак",
    "undo": "Отмени",
    "pullToRefresh": "Плъзнете за обновяване",
    "justNow": "току-що"
  },
  "auth": {
    "welcome": "Добре дошли в FishMemory",
    "tagline": "Вашият WhatsApp помощник за напомняния, сега в джоба ви.",
    "subtitle": "Вашият WhatsApp помощник за напомняния, сега в джоба ви.",
    "phoneLabel": "Вашият WhatsApp номер",
    "phoneHint": "Ще изпратим код за потвърждение чрез WhatsApp",
    "invalidPhone": "Моля, въведете валиден телефонен номер",
    "continue": "Продължи",
    "enterPhone": "Въведете вашия WhatsApp номер",
    "phonePlaceholder": "Телефонен номер",
    "sendCode": "Изпрати код",
    "verifyTitle": "Потвърдете номера си",
    "otpSentTo": "6-цифрен код беше изпратен на {{phone}} чрез WhatsApp",
    "enterFullCode": "Моля, въведете всички 6 цифри",
    "invalidOtp": "Невалиден код. Моля, опитайте отново.",
    "otpFailed": "Неуспешно изпращане на кода. Опитайте пак.",
    "otpResent": "Кодът е изпратен отново",
    "resendIn": "Повторно изпращане след {{seconds}}с",
    "resendCode": "Изпрати кода отново",
    "enterOtp": "Въведете кода, изпратен на WhatsApp",
    "verify": "Потвърди",
    "resend": "Изпрати отново",
    "wrongNumber": "Грешен номер?",
    "backToPhone": "Обратно към номера",
    "editPhone": "Редактирай номер",
    "error": "Грешка",
    "setupTitle": "Нека настроим",
    "setupSubtitle": "Винаги можете да промените това по-късно в Настройки",
    "namePlaceholder": "Вашето име",
    "letsGo": "Завърши настройката",
    "skipForNow": "Пропусни за сега"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Напишете съобщение...",
    "inputPlaceholder": "Напишете съобщение...",
    "typing": "FishMemory пише...",
    "online": "Онлайн",
    "connecting": "Свързване...",
    "reconnecting": "Повторно свързване...",
    "offline": "Офлайн",
    "empty": "Започнете разговор",
    "emptyHint": "Създайте напомняния, проверете графика си или поискайте помощ.",
    "emptyAction": "Изпрати пример за напомняне",
    "actions": "Действия в чата",
    "keep": "Запази съобщенията",
    "clearTitle": "Изчисти чата",
    "clearConfirm": "Изтриване на всички съобщения от това устройство? Това не може да бъде отменено.",
    "clear": "Изчисти чата",
    "optionSelected": "Избрано: {{label}}",
    "sendingSelection": "Изпращане...",
    "connectionLost": "Повторно свързване..."
  },
  "reminders": {
    "title": "Моите напомняния",
    "active": "Активни",
    "today": "Днес",
    "thisWeek": "Тази седмица",
    "history": "История",
    "items": "елементи",
    "emptyTitle": "Все още няма напомняния",
    "emptySubtitle": "Създайте от чата и ще се появи тук.",
    "emptyAction": "Отвори чат",
    "filterActive": "Активни",
    "filterToday": "Днес",
    "filterWeek": "Тази седмица",
    "filterHistory": "История",
    "emptyState": "Все още няма напомняния. Започнете чат!",
    "swipeDone": "Готово",
    "swipeSnooze": "Отлагане",
    "swipeDelete": "Изтрий",
    "search": "Търсене на напомняния...",
    "upcoming": "Предстоящи",
    "completed": "Завършени",
    "overdue": "Просрочени",
    "tomorrow": "Утре",
    "synced": "Синхронизирани {{value}}",
    "swipeHint": "Плъзнете напомняне за повече действия",
    "noResults": "Няма напомняния по вашето търсене",
    "noResultsHint": "Опитайте с друга дума или изчистете търсенето",
    "deleteAllFailed": "Неуспешно изтриване на всички напомняния"
  },
  "calendar": {
    "title": "Календар",
    "today": "Днес",
    "tomorrow": "Утре",
    "completed": "завършено",
    "noEvents": "Няма планирани събития",
    "noEventsSubtitle": "Изберете дата, за да видите напомняния и събития.",
    "googleEvent": "Google Календар",
    "legendActive": "Активни",
    "legendRecurring": "Повтарящи се",
    "legendDone": "Завършени",
    "legendGoogle": "Google",
    "previousMonth": "Предишен месец",
    "nextMonth": "Следващ месец",
    "previousYear": "Предишна година",
    "nextYear": "Следваща година",
    "goToToday": "Отиди на днес",
    "all": "Всички",
    "active": "Активни",
    "done": "Завършени",
    "paused": "Пауза"
  },
  "settings": {
    "title": "Настройки",
    "profile": "Профил",
    "name": "Показвано име",
    "enterName": "Въведете името си",
    "language": "Език",
    "uiLanguage": "Език на приложението",
    "uiLanguageHelp": "Променя езика на интерфейса, етикетите в календара и посоката на оформление само на това устройство.",
    "serverLanguage": "Език на чата",
    "serverLanguageHelp": "Променя езика на отговорите от сървъра и съобщенията за напомняния за вашия акаунт.",
    "timezone": "Часова зона",
    "currentTimezone": "Текуща часова зона",
    "timezoneHelp": "Всички часове на напомнянията се показват според тази часова зона.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Запази часова зона",
    "timezoneSaved": "Часовата зона е обновена",
    "detect": "Открий",
    "detectFailed": "Не можа да се открие часова зона",
    "autoDetect": "Автоматично откриване от GPS",
    "notifications": "Известия",
    "notificationsHelp": "Повторните напомняния контролират повтарящите се сигнали след доставяне на напомняне. Разрешенията за известия на устройството се управляват в настройките на телефона.",
    "pushEnabled": "Push известия",
    "autoDoneOnFire": "Автоматично маркиране като завършено при задействане",
    "autoDoneOnFireDesc": "Ако е изключено, напомнянията остават активни, докато не ги маркирате като завършени.",
    "googleCalendar": "Google Календар",
    "google": "Google Календар",
    "googleConnected": "Свързан",
    "googleDisconnected": "Не е свързан",
    "googleConnectedHelp": "Новите напомняния могат да се синхронизират автоматично с календара ви.",
    "googleDisconnectedHelp": "Свържете Google Календар, за да синхронизирате напомнянията и събитията.",
    "googleConnectFailed": "Неуспешно свързване с Google Календар",
    "connected": "Свързан",
    "disconnected": "Не е свързан",
    "connect": "Свържи",
    "disconnect": "Прекъсни връзката",
    "autoSync": "Автоматична синхронизация на нови напомняния",
    "autosync": "Автоматична синхронизация на нови напомняния",
    "subscription": "Абонамент",
    "trialUsed": "Пробен период: {{used}}/{{total}} използвани",
    "trialStatus": "Пробен период наличен",
    "activeStatus": "Активен абонамент",
    "expiredStatus": "Абонаментът е изтекъл",
    "unsubscribedStatus": "Не сте абонирани",
    "about": "За приложението",
    "version": "Версия",
    "logout": "Изход",
    "logoutTitle": "Изход",
    "logoutConfirm": "Сигурни ли сте, че искате да излезете?",
    "noName": "Име не е зададено",
    "serverConnection": "Връзка със сървъра",
    "serverUrl": "URL на сървъра",
    "serverEdit": "Редактирай",
    "saveReconnect": "Запази и свържи отново",
    "resetDefault": "Върни по подразбиране",
    "invalidServerUrlTitle": "Невалиден URL на сървъра",
    "invalidServerUrlMessage": "Въведете валиден http или https URL на сървъра, например https://example.com",
    "uiLanguageChangeFailed": "Неуспешна смяна на езика на приложението. Моля, опитайте отново.",
    "serverLanguageChangeFailed": "Неуспешна смяна на езика на чата. Моля, опитайте отново.",
    "timezoneChangeFailed": "Неуспешна смяна на часовата зона. Моля, опитайте отново.",
    "autoSyncChangeFailed": "Неуспешна промяна на автоматичната синхронизация. Моля, опитайте отново.",
    "nameChangeFailed": "Неуспешна промяна на показваното име. Моля, опитайте отново.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Детайли за напомнянето",
    "editTime": "Редактирай час",
    "rename": "Преименувай",
    "snooze": "Отложи",
    "snooze15": "Отложи с 15 минути",
    "pause": "Пауза",
    "pauseReminder": "Пауза на напомнянето",
    "resume": "Възобнови",
    "resumeReminder": "Възобнови напомнянето",
    "skip": "Пропусни следващото",
    "skipOccurrence": "Пропусни това повторение",
    "syncGoogle": "Синхронизирай с Google",
    "delete": "Изтрий",
    "deleteTitle": "Изтриване на напомняне",
    "deleteConfirm": "Това напомняне ще бъде изтрито завинаги.",
    "deleteRecurringTitle": "Изтриване на повтарящо се напомняне",
    "deleteRecurringMessage": "Искате ли да пропуснете това повторение или да изтриете цялата серия?",
    "deleteThisOccurrence": "Пропусни това повторение",
    "deleteEntireSeries": "Изтрий цялата серия",
    "done": "Готово",
    "markDone": "Маркирай като готово",
    "undo": "Възстанови",
    "undoPrompt": "Искате ли да го активирате отново? Възстановете сега.",
    "recurring": "Повтарящо се",
    "nextRun": "Следващо изпълнение",
    "oneTime": "Еднократно",
    "pending": "В очакване",
    "sent": "Изпратено",
    "paused": "Пауза",
    "active": "Активно",
    "snoozed": "Отложено",
    "localTime": "Показано в местното ви време",
    "recurrence": "Повтаряне",
    "created": "Създадено",
    "tags": "Етикети",
    "fireCount": "Брой изпълнения",
    "actions": "Действия",
    "none": "Няма",
    "snoozeFailed": "Неуспешно отлагане на напомнянето",
    "pauseFailed": "Неуспешна пауза на напомнянето",
    "resumeFailed": "Неуспешно възобновяване на напомнянето",
    "skipFailed": "Неуспешно пропускане на напомнянето",
    "doneFailed": "Неуспешно маркиране на напомнянето като готово",
    "undoFailed": "Неуспешно възстановяване на статуса на напомнянето",
    "deleteFailed": "Неуспешно изтриване на напомнянето",
    "rescheduleTitle": "Преустановяване?",
    "rescheduleMsg": "Това напомняне е просрочено. Искате ли да го пренасрочите?",
    "reschedule15": "След 15 минути",
    "reschedule60": "След 1 час",
    "keepOverdue": "Запази както е"
  },
  "onboarding": {
    "slide1Title": "Добре дошли в FishMemory",
    "slide1Sub": "Вашият личен помощник за напомняния — задвижван от WhatsApp и създаден за вашия джоб.",
    "slide2Title": "Просто чатете естествено",
    "slide2Sub": "Пишете напомняния както мислите: „Напомни ми да се обадя на мама утре в 15:00“ — ние се грижим за останалото.",
    "slide3Title": "Никога не пропускайте нищо",
    "slide3Sub": "Получавайте навременни известия, организирайте с етикети и бъдете в крак с всичко важно.",
    "getStarted": "Започнете",
    "next": "Напред",
    "firstReminderTitle": "Създайте първото си напомняне!",
    "firstReminderHint": "Опитайте да напишете нещо като:",
    "firstReminderExample": "Напомни ми да пия вода утре в 9 ч.",
    "gotIt": "Разбрах!",
    "notifRationaleTitle": "Бъдете навреме",
    "notifRationaleBody": "FishMemory се нуждае от известия, за да ви напомня навреме. Ще получавате сигнали само за създадените от вас напомняния.",
    "notifRationaleAllow": "Разреши известия",
    "notifRationaleLater": "Може по-късно",
    "swipeHint": "Плъзнете надясно за бързи действия →",
    "calendarDragHint": "Плъзнете за разширяване ↕"
  }
}
